import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { Select, Store } from '@ngxs/store';
import _ from 'lodash';
import { combineLatest, Observable, of, Subject } from 'rxjs';
import { distinctUntilChanged, map, skip, takeUntil, tap } from 'rxjs/operators';
import { CallHistoryFilterType } from 'src/app/samwebDescription/samweb/callHistory/callHistoryFilterType';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { IGridFilterItem } from '../../../samwebDescription/samweb/filters/IGridFilterItem';
import { GridFilterSettingsChanged, ToggleFilterPopup } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brick-filter-state/grid-filter.actions';
import { GridFilterState } from '../../../store/dashboard/brick-wall/brick-behaviour-state/brick-filter-state/grid-filter.state';

@Component({
   selector: 'samweb-grid-filter',
   templateUrl: './grid-filter.component.html',
   styleUrls: ['./grid-filter.component.scss'],
})
export class GridFilterComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   public filterIcon: IconDefinition = faFilter;

   public isFilterListOpen$: Observable<boolean>;

   public numSelected$: Observable<number>;

   @Input()
   public availableValues$: Observable<IGridFilterItem[]>;

   @Input()
   public filterId: string;

   @Input()
   public brickInstanceId: string;

   @Input()
   public gridId = 'default';

   @Output()
   public filteredValuesChanged = new EventEmitter();

   constructor(private store: Store) {}

   ngOnInit() {
      this.isFilterListOpen$ = this.store
         .select(GridFilterState.getIsFilterOpen)
         .pipe(map((filter) => filter(this.brickInstanceId, this.gridId, this.filterId)));

      this.numSelected$ = this.store.select(GridFilterState.selectedFilterValues).pipe(
         map((filter) => filter(this.brickInstanceId, this.gridId, this.filterId)),
         map((x) => x.length)
      );

      this.store
         .select(GridFilterState.selectedFilterValues)
         .pipe(
            map((filter) => filter(this.brickInstanceId, this.gridId, this.filterId)),
            distinctUntilChanged((prev, curr) => _.isEqual(prev, curr)),
            skip(1),
            tap(() => this.filteredValuesChanged.emit()),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   changeFilterValue(filterItem: IGridFilterItem, $event: any) {
      this.store.dispatch(new GridFilterSettingsChanged(filterItem, $event.currentTarget.checked, this.brickInstanceId, this.gridId, this.filterId));
   }

   isFilterSelected$(filterItem: IGridFilterItem): Observable<boolean> {
      return this.store
         .select(GridFilterState.getIsFilterSelected)
         .pipe(map((filterFn) => filterFn(this.brickInstanceId, this.gridId, this.filterId, filterItem.filterKey)));
   }

   toggleFilterPopup() {
      this.store.dispatch(new ToggleFilterPopup(this.brickInstanceId, this.gridId, this.filterId));
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
